<template>
  <div>
    <h2 class="headline-md mb-6">応募内容</h2>
    <div
      class="mb-20 p-8 bg-white rounded-lg"
      style="max-width: 986px"
    >
      <!--データがあるもしくは任意項目のうち何かが入力されている-->
      <div
        v-if="
          apply.estimated_lower_cost != null ||
          apply.estimated_upper_cost != null ||
          (apply.service_cases && apply.service_cases.length !== 0) ||
          apply.answer_to_desired_requirement !== null
        "
      >
        <div class="flex flex-col gap-10">
          <div v-if="apply.answer_to_desired_requirement">
            <h3 class="headline-sm mb-4">応募コメント</h3>
            <div class="body-md whitespace-pre-wrap">
              {{ apply.answer_to_desired_requirement }}
            </div>
          </div>
          <div v-if="apply.estimated_lower_cost || apply.estimated_upper_cost">
            <h3 class="headline-sm mb-4">費用目安</h3>
            <div class="flex flex-col gap-4">
              <div class="text-gray-92 title-lg">
                {{
                  apply.estimated_lower_cost
                    ? `${fullNumberFormat(apply.estimated_lower_cost)}円`
                    : ''
                }}〜{{
                  apply.estimated_upper_cost
                    ? `${fullNumberFormat(apply.estimated_upper_cost)}円`
                    : ''
                }}
              </div>
              <div v-if="apply.cost_comment">
                <div class="title-sm mb-1">費用目安の補足</div>
                <div class="text-gray-92 body-md whitespace-pre-wrap">
                  {{ apply.cost_comment }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              apply.service_cases?.length > 0 ||
              apply.service_case_comment !== ''
            "
          >
            <h3 class="headline-sm text-gray-92 mb-4">実績</h3>
            <div v-if="apply.service_case_comment" class="mb-6">
              <div class="title-sm mb-1">実績のアピール・補足</div>
              <div class="text-gray-92 body-md whitespace-pre-wrap">
                {{ apply.service_case_comment }}
              </div>
            </div>
            <div v-if="apply.service_cases?.length > 0">
              <div class="title-sm mb-1">
                参考実績（{{ apply.service_cases?.length }}件）
              </div>
              <div
                class="box-border border rounded-2xl px-6 pt-6 pb-2 text-gray-92 mt-4"
                v-for="serviceCase in apply.service_cases"
                :key="serviceCase.id"
                :class="[
                  serviceCase.isRecommended
                    ? 'border-primary-light-medium recommended'
                    : 'border-gray-12',
                ]"
              >
                <div
                  class="recommended-badge"
                  v-if="serviceCase.isRecommended"
                  @mouseover="state.annotation.isShow = true"
                  @mouseleave="state.annotation.isShow = false"
                />
                <div
                  v-if="serviceCase.isRecommended"
                  v-show="state.annotation.isShow"
                  style="position: absolute; width: 320px; height: 71px"
                >
                  <div
                    style="
                      display: block;
                      position: absolute;
                      top: -116px;
                      left: -37px;
                      width: 100%;
                    "
                  >
                    <div
                      class="text-white bg-gray-62 py-1 px-3 rounded-sm body-md"
                    >
                      <div>
                        応募企業が選んだ、最もアピールしたい実績です。募集内容に特に近いものが選ばれています。
                      </div>
                    </div>
                  </div>
                </div>
                <ApplicationDetailServiceCase :serviceCase="serviceCase" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-gray-62 text-center">
          <div>この応募には入力がありません。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, inject } from 'vue';
import axios from '@/utils/axiosAuth.js';
import utils from '@/utils/utils.js';
import { fullNumberFormat } from '@/utils/fullNumberFormat';
import ApplicationDetailServiceCase from '@/views/tx/vue/ApplicationDetailServiceCase';

export default {
  props: {
    id: {
      type: [String, Number],
    },
    selectId: {
      type: [String, Number],
    },
  },
  components: {
    ApplicationDetailServiceCase,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const state = reactive({
      apply: {},
      annotation: {
        isShow: false,
      },
    });
    const txType = 'tx-select';

    const getApplication = async () => {
      const response = await axios
        .get(`/transaction-selects/${props.selectId ?? props.id}/application`)
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      if (response && response.data.data) {
        state.apply = response.data.data;
      }
    };

    onMounted(() => {
      getApplication();
    });
    return {
      ...toRefs(state),
      txType,
      utils,
      fullNumberFormat,
      state,
    };
  },
};
</script>
<style>
.recommended {
  position: relative;
}
.recommended-badge {
  content: url('~@/assets/icons/RecommendedBadge.svg');
  position: absolute;
  top: -13px;
  left: -13px;
}
</style>
